import { MenuEntry } from '@pancakeswap-libs/uikit'

const config: MenuEntry[] = [
  {
    label: 'Home',
    icon: 'HomeIcon',
    href: 'https://pankuku.net/',
    calloutClass: 'menulink'
  },
   {
    label: 'About',
    icon: 'AboutIcon',
    href: 'https://pankuku.gitbook.io/kuku_wiki/',
    calloutClass: 'menulink'
  },
  {
    label: 'Trade',
    icon: 'TradeIcon',
    calloutClass: 'menulink',
    items: [
      {
        label: 'Exchange',
        href: 'https://exchange.pankuku.net/#/swap',
      },
      {
        label: 'Liquidity',
        href: 'https://exchange.pankuku.net/#/pool',
      },
    ],
  },
  {
    label: 'Farms',
    icon: 'FarmIcon',
    href: '/farms',
    calloutClass: 'menulink'
  },
  {
    label: 'Pools',
    icon: 'PoolIcon',
    href: '/pools',
    calloutClass: 'menulink'
  },
  {
    label: 'IDO',
    icon: 'InfoIcon',
    href: 'https://ido.pankuku.net/',
  },
  {
    label: 'Shop',
    icon: 'ShopIcon',
    href: 'https://kukushop.net/',
  },
  {
    label: 'NFT',
    icon: 'NftIcon',
    href: 'https://nft.pankuku.net/',
    calloutClass: 'menulink'
  },
  {
    label: 'Lottery',
    icon: 'TicketIcon',
    href: 'https://nft.pankuku.net/lottery/',
    calloutClass: 'menulink'
  },
  {
    label: 'Contact',
    icon: 'ContactIcon',
    href: 'https://nft.pankuku.net/contact',
    calloutClass: 'menulink'
  },
  {
    label: 'Privacy Policy',
    icon: 'privacyIcon',
    href: 'https://pankuku.gitbook.io/kuku_wiki/legal/policies/privacy',
    calloutClass: 'menulink'
  },
  // {
  //   label: 'Contact',
  //   icon: 'ContactIcon',
  //   href: '/',
  //   calloutClass: 'menulink'
  // },
  // {
  //   label: 'Info',
  //   icon: 'InfoIcon',
  //   items: [
  //     {
  //       label: 'Swap',
  //       href: '#',
  //     },
  //     {
  //       label: 'CoinGecko',
  //       href: '#',
  //     },
  //     {
  //       label: 'CoinMarketCap',
  //       href: '#',
  //     },
  //     {
  //       label: 'AstroTools',
  //       href: '#',
  //     },
  //   ],
  // },
  // {
  //   label: 'More',
  //   icon: 'MoreIcon',
  //   calloutClass: 'menulink',
  //   items: [
  //     {
  //       label: 'Blog',
  //       href: '#',
  //     },
  //   ],
  // },
]

export default config
